import '../../index.css'

import { Link } from 'react-router-dom'
import React from 'react'
import { classNames } from 'helpers'

export interface MenuItemProps {
  name: string
  href: string
  current?: any
  icon: any
}

const styles = {
  base:
    'w-24 h-20 overflow-y-auto flex items-center justify-center text-xs leading-3 text-center',
  current:
    'bg-indigo-2 hover:bg-indigo-1 text-white shadow-4xl hover:shadow-none font-manrope',
  notCurrent: 'text-indigo-2 hover:bg-blue-0',
}

const MenuItem = React.forwardRef<
  HTMLAnchorElement,
  MenuItemProps
>(({ name, href, current, icon, ...args }, ref) => {
  const Icon = icon ?? false

  return (
    <div
      className={classNames(
        styles.base,
        current ? styles.current : styles.notCurrent
      )}
      {...args}
    >
      <Link
        key={name}
        to={href}
        aria-current={current ? 'page' : undefined}
        className="flex flex-col items-center w-full group"
      >
        {Icon && (
          <Icon
            fill={current ? 'white' : '#3E4685'}
            className="w-6 h-6 text-white group-hover:text-white"
          />
        )}
        <span className="mt-1 text-xs">{name}</span>
      </Link>
    </div>
  )
})

MenuItem.defaultProps = {
  current: false,
}

export default MenuItem
